import Vue from 'vue'
import Vuex from 'vuex'
import globalConfigApi from '@/api/global-config'
import userInfoApi from '@/api/user-info'
import moduleApi from '@/api/module'

Vue.use(Vuex)

const types = {
    'LOADING': 'loading',

    'SET_GLOBAL_CONFIG': 'setGlobalConfig',

    'SET_USER_INFO': 'SET_USER_INFO',

    'SET_USER_MODULE': 'SET_USER_MODULE'
}

const Store = new Vuex.Store({
    state: {
        loading: false,
        globalConfig: {},
        userInfo: {
            menu:[],
            button:{},
        },
        userModule: null,
    },
    mutations: {
        [types.LOADING](state, loading) {
            state.loading = loading;
        },
        [types.SET_GLOBAL_CONFIG](state, config) {
            state.globalConfig = config;
        },
        [types.SET_USER_INFO](state, userInfo) {
            state.userInfo = userInfo;
        },
        [types.SET_USER_MODULE](state, module) {
            state.userModule = module;
        },
    },
    actions: {
        loading({ commit }) {
            commit(types.LOADING)
        },

        // 获取全局配置
        getConfig({ commit }) {
            let useCache = false;
            globalConfigApi(useCache).then(v => {
                commit(types.SET_GLOBAL_CONFIG, v.data)
            })
        },

        // 获取用户模块(菜单栏和按钮)
        getUserModule({ commit }) {


            const pageParentId = localStorage.pageParentId;
            const pageId = localStorage.pageId;
            moduleApi.listUserModule().then(v => {

                function eachMenu(data, index = 0) {
                    return data.map((v) => {
                        v.name = v.label;
                        v.id = v.moduleId;
                        v.open = false;
                        v.active = false;
                        v.iconPath = v.defaultIcon;
                        v.selectedIconPath = v.lightIcon;

                        // 高亮当前URL
                        if(pageId && v.id == pageId){
                            v.active = true;
                        }

                        // 展开菜单
                        if(pageParentId && v.id == pageParentId){
                            v.open = true;
                        }


                        delete v.icon;

                        if (v.children) {
                            v.children = eachMenu(v.children, index + 1)
                        }

                        return v;
                    })
                }

                const menu = eachMenu(v.data.menu);

                // 把后台的数据转成对象
                const button = {};
                v.data.button.map(v => {
                    button[v.url] = {
                        url: v.url,
                        label: v.label,
                    }
                })

                commit(types.SET_USER_MODULE, {
                    menu,
                    button,
                })
            })
        },

        // 获取用户信息
        getUserInfo({ commit }) {
            userInfoApi.base().then(v => {
                commit(types.SET_USER_INFO, v.data)
            })
        },
    },
    modules: {
    },
})

export default Store
